import { useCallback } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { ListCell } from '@cbhq/cds-web/cells';
import { Box } from '@cbhq/cds-web/layout/Box';
import { Tooltip } from '@cbhq/cds-web/overlays';
import { CoinbaseProfileMenuResource } from '@cbhq/identity-api-hooks/profile-menu/types';

const messages = defineMessages({
  legalEntity: {
    id: 'ResourceItem.legalEntity',
    defaultMessage: 'Entity',
    description: 'Description for the legal entity resource type',
  },
  user: {
    id: 'ResourceItem.user',
    defaultMessage: 'Personal',
    description: 'Description for the personal resource type',
  },
});

const OUTER_SPACING = { paddingX: 0, paddingY: 0 } as const;
const INNER_SPACING = { paddingX: 5, paddingY: 1 } as const;

type ResourceItemProps = {
  resource: CoinbaseProfileMenuResource;
  onPress: (resourceId: string) => void;
  selected?: boolean;
};
export function ResourceItem({ resource, onPress, selected }: ResourceItemProps) {
  const { formatMessage } = useIntl();

  const { name, identityAccountId, resourceType } = resource;
  if (!identityAccountId) {
    // should never happen
    throw new Error('ResourceItem: identityAccountId is required');
  }

  const description =
    resourceType === 'legal_entity'
      ? formatMessage(messages.legalEntity)
      : formatMessage(messages.user);

  const handlePress = useCallback(() => {
    onPress(identityAccountId);
  }, [onPress, identityAccountId]);

  return (
    <Tooltip content={name} placement="right">
      <Box width="100%">
        <ListCell
          compact
          key={identityAccountId}
          title={name}
          description={description}
          onClick={handlePress}
          selected={selected}
          borderRadius={0}
          outerSpacing={OUTER_SPACING}
          innerSpacing={INNER_SPACING}
        />
      </Box>
    </Tooltip>
  );
}
